// Generated by scripts/sync-profile-data.cjs from shared/. Do not edit directly.
module.exports = [
  {
    "id": "CN",
    "code": "86",
    "label": "中国内地 +86"
  },
  {
    "id": "HK",
    "code": "852",
    "label": "中国香港 +852"
  },
  {
    "id": "MO",
    "code": "853",
    "label": "中国澳门 +853"
  },
  {
    "id": "TW",
    "code": "886",
    "label": "中国台湾 +886"
  },
  {
    "id": "AL",
    "code": "355",
    "label": "阿尔巴尼亚 +355"
  },
  {
    "id": "DZ",
    "code": "213",
    "label": "阿尔及利亚 +213"
  },
  {
    "id": "AF",
    "code": "93",
    "label": "阿富汗 +93"
  },
  {
    "id": "AR",
    "code": "54",
    "label": "阿根廷 +54"
  },
  {
    "id": "AE",
    "code": "971",
    "label": "阿拉伯联合酋长国 +971"
  },
  {
    "id": "AW",
    "code": "297",
    "label": "阿鲁巴 +297"
  },
  {
    "id": "OM",
    "code": "968",
    "label": "阿曼 +968"
  },
  {
    "id": "AZ",
    "code": "994",
    "label": "阿塞拜疆 +994"
  },
  {
    "id": "AC",
    "code": "247",
    "label": "阿森松岛 +247"
  },
  {
    "id": "EG",
    "code": "20",
    "label": "埃及 +20"
  },
  {
    "id": "ET",
    "code": "251",
    "label": "埃塞俄比亚 +251"
  },
  {
    "id": "IE",
    "code": "353",
    "label": "爱尔兰 +353"
  },
  {
    "id": "EE",
    "code": "372",
    "label": "爱沙尼亚 +372"
  },
  {
    "id": "AD",
    "code": "376",
    "label": "安道尔 +376"
  },
  {
    "id": "AO",
    "code": "244",
    "label": "安哥拉 +244"
  },
  {
    "id": "AI",
    "code": "1",
    "label": "安圭拉 +1"
  },
  {
    "id": "AG",
    "code": "1",
    "label": "安提瓜和巴布达 +1"
  },
  {
    "id": "AT",
    "code": "43",
    "label": "奥地利 +43"
  },
  {
    "id": "AX",
    "code": "358",
    "label": "奥兰群岛 +358"
  },
  {
    "id": "AU",
    "code": "61",
    "label": "澳大利亚 +61"
  },
  {
    "id": "BB",
    "code": "1",
    "label": "巴巴多斯 +1"
  },
  {
    "id": "PG",
    "code": "675",
    "label": "巴布亚新几内亚 +675"
  },
  {
    "id": "BS",
    "code": "1",
    "label": "巴哈马 +1"
  },
  {
    "id": "PK",
    "code": "92",
    "label": "巴基斯坦 +92"
  },
  {
    "id": "PY",
    "code": "595",
    "label": "巴拉圭 +595"
  },
  {
    "id": "PS",
    "code": "970",
    "label": "巴勒斯坦领土 +970"
  },
  {
    "id": "BH",
    "code": "973",
    "label": "巴林 +973"
  },
  {
    "id": "PA",
    "code": "507",
    "label": "巴拿马 +507"
  },
  {
    "id": "BR",
    "code": "55",
    "label": "巴西 +55"
  },
  {
    "id": "BY",
    "code": "375",
    "label": "白俄罗斯 +375"
  },
  {
    "id": "BM",
    "code": "1",
    "label": "百慕大 +1"
  },
  {
    "id": "BG",
    "code": "359",
    "label": "保加利亚 +359"
  },
  {
    "id": "MP",
    "code": "1",
    "label": "北马里亚纳群岛 +1"
  },
  {
    "id": "MK",
    "code": "389",
    "label": "北马其顿 +389"
  },
  {
    "id": "BJ",
    "code": "229",
    "label": "贝宁 +229"
  },
  {
    "id": "BE",
    "code": "32",
    "label": "比利时 +32"
  },
  {
    "id": "IS",
    "code": "354",
    "label": "冰岛 +354"
  },
  {
    "id": "PR",
    "code": "1",
    "label": "波多黎各 +1"
  },
  {
    "id": "PL",
    "code": "48",
    "label": "波兰 +48"
  },
  {
    "id": "BA",
    "code": "387",
    "label": "波斯尼亚和黑塞哥维那 +387"
  },
  {
    "id": "BO",
    "code": "591",
    "label": "玻利维亚 +591"
  },
  {
    "id": "BZ",
    "code": "501",
    "label": "伯利兹 +501"
  },
  {
    "id": "BW",
    "code": "267",
    "label": "博茨瓦纳 +267"
  },
  {
    "id": "BT",
    "code": "975",
    "label": "不丹 +975"
  },
  {
    "id": "BF",
    "code": "226",
    "label": "布基纳法索 +226"
  },
  {
    "id": "BI",
    "code": "257",
    "label": "布隆迪 +257"
  },
  {
    "id": "KP",
    "code": "850",
    "label": "朝鲜 +850"
  },
  {
    "id": "GQ",
    "code": "240",
    "label": "赤道几内亚 +240"
  },
  {
    "id": "DK",
    "code": "45",
    "label": "丹麦 +45"
  },
  {
    "id": "DE",
    "code": "49",
    "label": "德国 +49"
  },
  {
    "id": "TL",
    "code": "670",
    "label": "东帝汶 +670"
  },
  {
    "id": "TG",
    "code": "228",
    "label": "多哥 +228"
  },
  {
    "id": "DO",
    "code": "1",
    "label": "多米尼加共和国 +1"
  },
  {
    "id": "DM",
    "code": "1",
    "label": "多米尼克 +1"
  },
  {
    "id": "RU",
    "code": "7",
    "label": "俄罗斯 +7"
  },
  {
    "id": "EC",
    "code": "593",
    "label": "厄瓜多尔 +593"
  },
  {
    "id": "ER",
    "code": "291",
    "label": "厄立特里亚 +291"
  },
  {
    "id": "FR",
    "code": "33",
    "label": "法国 +33"
  },
  {
    "id": "FO",
    "code": "298",
    "label": "法罗群岛 +298"
  },
  {
    "id": "PF",
    "code": "689",
    "label": "法属波利尼西亚 +689"
  },
  {
    "id": "GF",
    "code": "594",
    "label": "法属圭亚那 +594"
  },
  {
    "id": "MF",
    "code": "590",
    "label": "法属圣马丁 +590"
  },
  {
    "id": "VA",
    "code": "39",
    "label": "梵蒂冈 +39"
  },
  {
    "id": "PH",
    "code": "63",
    "label": "菲律宾 +63"
  },
  {
    "id": "FJ",
    "code": "679",
    "label": "斐济 +679"
  },
  {
    "id": "FI",
    "code": "358",
    "label": "芬兰 +358"
  },
  {
    "id": "CV",
    "code": "238",
    "label": "佛得角 +238"
  },
  {
    "id": "FK",
    "code": "500",
    "label": "福克兰群岛 +500"
  },
  {
    "id": "GM",
    "code": "220",
    "label": "冈比亚 +220"
  },
  {
    "id": "CG",
    "code": "242",
    "label": "刚果（布） +242"
  },
  {
    "id": "CD",
    "code": "243",
    "label": "刚果（金） +243"
  },
  {
    "id": "CO",
    "code": "57",
    "label": "哥伦比亚 +57"
  },
  {
    "id": "CR",
    "code": "506",
    "label": "哥斯达黎加 +506"
  },
  {
    "id": "GD",
    "code": "1",
    "label": "格林纳达 +1"
  },
  {
    "id": "GL",
    "code": "299",
    "label": "格陵兰 +299"
  },
  {
    "id": "GE",
    "code": "995",
    "label": "格鲁吉亚 +995"
  },
  {
    "id": "GG",
    "code": "44",
    "label": "根西岛 +44"
  },
  {
    "id": "CU",
    "code": "53",
    "label": "古巴 +53"
  },
  {
    "id": "GP",
    "code": "590",
    "label": "瓜德罗普 +590"
  },
  {
    "id": "GU",
    "code": "1",
    "label": "关岛 +1"
  },
  {
    "id": "GY",
    "code": "592",
    "label": "圭亚那 +592"
  },
  {
    "id": "KZ",
    "code": "7",
    "label": "哈萨克斯坦 +7"
  },
  {
    "id": "HT",
    "code": "509",
    "label": "海地 +509"
  },
  {
    "id": "KR",
    "code": "82",
    "label": "韩国 +82"
  },
  {
    "id": "NL",
    "code": "31",
    "label": "荷兰 +31"
  },
  {
    "id": "BQ",
    "code": "599",
    "label": "荷属加勒比区 +599"
  },
  {
    "id": "SX",
    "code": "1",
    "label": "荷属圣马丁 +1"
  },
  {
    "id": "ME",
    "code": "382",
    "label": "黑山 +382"
  },
  {
    "id": "HN",
    "code": "504",
    "label": "洪都拉斯 +504"
  },
  {
    "id": "KI",
    "code": "686",
    "label": "基里巴斯 +686"
  },
  {
    "id": "DJ",
    "code": "253",
    "label": "吉布提 +253"
  },
  {
    "id": "KG",
    "code": "996",
    "label": "吉尔吉斯斯坦 +996"
  },
  {
    "id": "GN",
    "code": "224",
    "label": "几内亚 +224"
  },
  {
    "id": "GW",
    "code": "245",
    "label": "几内亚比绍 +245"
  },
  {
    "id": "CA",
    "code": "1",
    "label": "加拿大 +1"
  },
  {
    "id": "GH",
    "code": "233",
    "label": "加纳 +233"
  },
  {
    "id": "GA",
    "code": "241",
    "label": "加蓬 +241"
  },
  {
    "id": "KH",
    "code": "855",
    "label": "柬埔寨 +855"
  },
  {
    "id": "CZ",
    "code": "420",
    "label": "捷克 +420"
  },
  {
    "id": "ZW",
    "code": "263",
    "label": "津巴布韦 +263"
  },
  {
    "id": "CM",
    "code": "237",
    "label": "喀麦隆 +237"
  },
  {
    "id": "QA",
    "code": "974",
    "label": "卡塔尔 +974"
  },
  {
    "id": "KY",
    "code": "1",
    "label": "开曼群岛 +1"
  },
  {
    "id": "CC",
    "code": "61",
    "label": "科科斯（基林）群岛 +61"
  },
  {
    "id": "KM",
    "code": "269",
    "label": "科摩罗 +269"
  },
  {
    "id": "XK",
    "code": "383",
    "label": "科索沃 +383"
  },
  {
    "id": "CI",
    "code": "225",
    "label": "科特迪瓦 +225"
  },
  {
    "id": "KW",
    "code": "965",
    "label": "科威特 +965"
  },
  {
    "id": "HR",
    "code": "385",
    "label": "克罗地亚 +385"
  },
  {
    "id": "KE",
    "code": "254",
    "label": "肯尼亚 +254"
  },
  {
    "id": "CK",
    "code": "682",
    "label": "库克群岛 +682"
  },
  {
    "id": "CW",
    "code": "599",
    "label": "库拉索 +599"
  },
  {
    "id": "LV",
    "code": "371",
    "label": "拉脱维亚 +371"
  },
  {
    "id": "LS",
    "code": "266",
    "label": "莱索托 +266"
  },
  {
    "id": "LA",
    "code": "856",
    "label": "老挝 +856"
  },
  {
    "id": "LB",
    "code": "961",
    "label": "黎巴嫩 +961"
  },
  {
    "id": "LT",
    "code": "370",
    "label": "立陶宛 +370"
  },
  {
    "id": "LR",
    "code": "231",
    "label": "利比里亚 +231"
  },
  {
    "id": "LY",
    "code": "218",
    "label": "利比亚 +218"
  },
  {
    "id": "LI",
    "code": "423",
    "label": "列支敦士登 +423"
  },
  {
    "id": "RE",
    "code": "262",
    "label": "留尼汪 +262"
  },
  {
    "id": "LU",
    "code": "352",
    "label": "卢森堡 +352"
  },
  {
    "id": "RW",
    "code": "250",
    "label": "卢旺达 +250"
  },
  {
    "id": "RO",
    "code": "40",
    "label": "罗马尼亚 +40"
  },
  {
    "id": "MG",
    "code": "261",
    "label": "马达加斯加 +261"
  },
  {
    "id": "IM",
    "code": "44",
    "label": "马恩岛 +44"
  },
  {
    "id": "MV",
    "code": "960",
    "label": "马尔代夫 +960"
  },
  {
    "id": "MT",
    "code": "356",
    "label": "马耳他 +356"
  },
  {
    "id": "MW",
    "code": "265",
    "label": "马拉维 +265"
  },
  {
    "id": "MY",
    "code": "60",
    "label": "马来西亚 +60"
  },
  {
    "id": "ML",
    "code": "223",
    "label": "马里 +223"
  },
  {
    "id": "MH",
    "code": "692",
    "label": "马绍尔群岛 +692"
  },
  {
    "id": "MQ",
    "code": "596",
    "label": "马提尼克 +596"
  },
  {
    "id": "YT",
    "code": "262",
    "label": "马约特 +262"
  },
  {
    "id": "MU",
    "code": "230",
    "label": "毛里求斯 +230"
  },
  {
    "id": "MR",
    "code": "222",
    "label": "毛里塔尼亚 +222"
  },
  {
    "id": "US",
    "code": "1",
    "label": "美国 +1"
  },
  {
    "id": "AS",
    "code": "1",
    "label": "美属萨摩亚 +1"
  },
  {
    "id": "VI",
    "code": "1",
    "label": "美属维尔京群岛 +1"
  },
  {
    "id": "MN",
    "code": "976",
    "label": "蒙古 +976"
  },
  {
    "id": "MS",
    "code": "1",
    "label": "蒙特塞拉特 +1"
  },
  {
    "id": "BD",
    "code": "880",
    "label": "孟加拉国 +880"
  },
  {
    "id": "PE",
    "code": "51",
    "label": "秘鲁 +51"
  },
  {
    "id": "FM",
    "code": "691",
    "label": "密克罗尼西亚 +691"
  },
  {
    "id": "MM",
    "code": "95",
    "label": "缅甸 +95"
  },
  {
    "id": "MD",
    "code": "373",
    "label": "摩尔多瓦 +373"
  },
  {
    "id": "MA",
    "code": "212",
    "label": "摩洛哥 +212"
  },
  {
    "id": "MC",
    "code": "377",
    "label": "摩纳哥 +377"
  },
  {
    "id": "MZ",
    "code": "258",
    "label": "莫桑比克 +258"
  },
  {
    "id": "MX",
    "code": "52",
    "label": "墨西哥 +52"
  },
  {
    "id": "NA",
    "code": "264",
    "label": "纳米比亚 +264"
  },
  {
    "id": "ZA",
    "code": "27",
    "label": "南非 +27"
  },
  {
    "id": "SS",
    "code": "211",
    "label": "南苏丹 +211"
  },
  {
    "id": "NR",
    "code": "674",
    "label": "瑙鲁 +674"
  },
  {
    "id": "NI",
    "code": "505",
    "label": "尼加拉瓜 +505"
  },
  {
    "id": "NP",
    "code": "977",
    "label": "尼泊尔 +977"
  },
  {
    "id": "NE",
    "code": "227",
    "label": "尼日尔 +227"
  },
  {
    "id": "NG",
    "code": "234",
    "label": "尼日利亚 +234"
  },
  {
    "id": "NU",
    "code": "683",
    "label": "纽埃 +683"
  },
  {
    "id": "NO",
    "code": "47",
    "label": "挪威 +47"
  },
  {
    "id": "NF",
    "code": "672",
    "label": "诺福克岛 +672"
  },
  {
    "id": "PW",
    "code": "680",
    "label": "帕劳 +680"
  },
  {
    "id": "PT",
    "code": "351",
    "label": "葡萄牙 +351"
  },
  {
    "id": "JP",
    "code": "81",
    "label": "日本 +81"
  },
  {
    "id": "SE",
    "code": "46",
    "label": "瑞典 +46"
  },
  {
    "id": "CH",
    "code": "41",
    "label": "瑞士 +41"
  },
  {
    "id": "SV",
    "code": "503",
    "label": "萨尔瓦多 +503"
  },
  {
    "id": "WS",
    "code": "685",
    "label": "萨摩亚 +685"
  },
  {
    "id": "RS",
    "code": "381",
    "label": "塞尔维亚 +381"
  },
  {
    "id": "SL",
    "code": "232",
    "label": "塞拉利昂 +232"
  },
  {
    "id": "SN",
    "code": "221",
    "label": "塞内加尔 +221"
  },
  {
    "id": "CY",
    "code": "357",
    "label": "塞浦路斯 +357"
  },
  {
    "id": "SC",
    "code": "248",
    "label": "塞舌尔 +248"
  },
  {
    "id": "SA",
    "code": "966",
    "label": "沙特阿拉伯 +966"
  },
  {
    "id": "BL",
    "code": "590",
    "label": "圣巴泰勒米 +590"
  },
  {
    "id": "CX",
    "code": "61",
    "label": "圣诞岛 +61"
  },
  {
    "id": "ST",
    "code": "239",
    "label": "圣多美和普林西比 +239"
  },
  {
    "id": "SH",
    "code": "290",
    "label": "圣赫勒拿 +290"
  },
  {
    "id": "KN",
    "code": "1",
    "label": "圣基茨和尼维斯 +1"
  },
  {
    "id": "LC",
    "code": "1",
    "label": "圣卢西亚 +1"
  },
  {
    "id": "SM",
    "code": "378",
    "label": "圣马力诺 +378"
  },
  {
    "id": "PM",
    "code": "508",
    "label": "圣皮埃尔和密克隆群岛 +508"
  },
  {
    "id": "VC",
    "code": "1",
    "label": "圣文森特和格林纳丁斯 +1"
  },
  {
    "id": "LK",
    "code": "94",
    "label": "斯里兰卡 +94"
  },
  {
    "id": "SK",
    "code": "421",
    "label": "斯洛伐克 +421"
  },
  {
    "id": "SI",
    "code": "386",
    "label": "斯洛文尼亚 +386"
  },
  {
    "id": "SJ",
    "code": "47",
    "label": "斯瓦尔巴和扬马延 +47"
  },
  {
    "id": "SZ",
    "code": "268",
    "label": "斯威士兰 +268"
  },
  {
    "id": "SD",
    "code": "249",
    "label": "苏丹 +249"
  },
  {
    "id": "SR",
    "code": "597",
    "label": "苏里南 +597"
  },
  {
    "id": "SB",
    "code": "677",
    "label": "所罗门群岛 +677"
  },
  {
    "id": "SO",
    "code": "252",
    "label": "索马里 +252"
  },
  {
    "id": "TJ",
    "code": "992",
    "label": "塔吉克斯坦 +992"
  },
  {
    "id": "TH",
    "code": "66",
    "label": "泰国 +66"
  },
  {
    "id": "TZ",
    "code": "255",
    "label": "坦桑尼亚 +255"
  },
  {
    "id": "TO",
    "code": "676",
    "label": "汤加 +676"
  },
  {
    "id": "TC",
    "code": "1",
    "label": "特克斯和凯科斯群岛 +1"
  },
  {
    "id": "TA",
    "code": "290",
    "label": "特里斯坦-达库尼亚群岛 +290"
  },
  {
    "id": "TT",
    "code": "1",
    "label": "特立尼达和多巴哥 +1"
  },
  {
    "id": "TN",
    "code": "216",
    "label": "突尼斯 +216"
  },
  {
    "id": "TV",
    "code": "688",
    "label": "图瓦卢 +688"
  },
  {
    "id": "TR",
    "code": "90",
    "label": "土耳其 +90"
  },
  {
    "id": "TM",
    "code": "993",
    "label": "土库曼斯坦 +993"
  },
  {
    "id": "TK",
    "code": "690",
    "label": "托克劳 +690"
  },
  {
    "id": "WF",
    "code": "681",
    "label": "瓦利斯和富图纳 +681"
  },
  {
    "id": "VU",
    "code": "678",
    "label": "瓦努阿图 +678"
  },
  {
    "id": "GT",
    "code": "502",
    "label": "危地马拉 +502"
  },
  {
    "id": "VE",
    "code": "58",
    "label": "委内瑞拉 +58"
  },
  {
    "id": "BN",
    "code": "673",
    "label": "文莱 +673"
  },
  {
    "id": "UG",
    "code": "256",
    "label": "乌干达 +256"
  },
  {
    "id": "UA",
    "code": "380",
    "label": "乌克兰 +380"
  },
  {
    "id": "UY",
    "code": "598",
    "label": "乌拉圭 +598"
  },
  {
    "id": "UZ",
    "code": "998",
    "label": "乌兹别克斯坦 +998"
  },
  {
    "id": "ES",
    "code": "34",
    "label": "西班牙 +34"
  },
  {
    "id": "EH",
    "code": "212",
    "label": "西撒哈拉 +212"
  },
  {
    "id": "GR",
    "code": "30",
    "label": "希腊 +30"
  },
  {
    "id": "SG",
    "code": "65",
    "label": "新加坡 +65"
  },
  {
    "id": "NC",
    "code": "687",
    "label": "新喀里多尼亚 +687"
  },
  {
    "id": "NZ",
    "code": "64",
    "label": "新西兰 +64"
  },
  {
    "id": "HU",
    "code": "36",
    "label": "匈牙利 +36"
  },
  {
    "id": "SY",
    "code": "963",
    "label": "叙利亚 +963"
  },
  {
    "id": "JM",
    "code": "1",
    "label": "牙买加 +1"
  },
  {
    "id": "AM",
    "code": "374",
    "label": "亚美尼亚 +374"
  },
  {
    "id": "YE",
    "code": "967",
    "label": "也门 +967"
  },
  {
    "id": "IQ",
    "code": "964",
    "label": "伊拉克 +964"
  },
  {
    "id": "IR",
    "code": "98",
    "label": "伊朗 +98"
  },
  {
    "id": "IL",
    "code": "972",
    "label": "以色列 +972"
  },
  {
    "id": "IT",
    "code": "39",
    "label": "意大利 +39"
  },
  {
    "id": "IN",
    "code": "91",
    "label": "印度 +91"
  },
  {
    "id": "ID",
    "code": "62",
    "label": "印度尼西亚 +62"
  },
  {
    "id": "GB",
    "code": "44",
    "label": "英国 +44"
  },
  {
    "id": "VG",
    "code": "1",
    "label": "英属维尔京群岛 +1"
  },
  {
    "id": "IO",
    "code": "246",
    "label": "英属印度洋领地 +246"
  },
  {
    "id": "JO",
    "code": "962",
    "label": "约旦 +962"
  },
  {
    "id": "VN",
    "code": "84",
    "label": "越南 +84"
  },
  {
    "id": "ZM",
    "code": "260",
    "label": "赞比亚 +260"
  },
  {
    "id": "JE",
    "code": "44",
    "label": "泽西岛 +44"
  },
  {
    "id": "TD",
    "code": "235",
    "label": "乍得 +235"
  },
  {
    "id": "GI",
    "code": "350",
    "label": "直布罗陀 +350"
  },
  {
    "id": "CL",
    "code": "56",
    "label": "智利 +56"
  },
  {
    "id": "CF",
    "code": "236",
    "label": "中非共和国 +236"
  }
]
